// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BarChartOutlinedSvg from "@fishx/icons-svg/es/asn/BarChartOutlined";
import FishxIcon from '../components/FishxIcon';

var BarChartOutlined = function BarChartOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BarChartOutlinedSvg
  }));
};

BarChartOutlined.displayName = 'BarChartOutlined';
export default React.forwardRef(BarChartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BarChartOutlined.js
// module id = 2051
// module chunks = 0